import http from '@/utils/http/index';
// 添加企业主

export function addShareholderInfo(params) {
  return http.post('/merchant/faceAuth/addShareholderInfo', params);
}
// 查看企业主
export function queryShareholderInfo(params) {
    return http.get('/merchant/faceAuth/queryShareholderInfo', params);
  }
// 删除企业主
export function deleteShareholderInfo(params) {
    return http.post(`/merchant/faceAuth/deleteShareholderInfo?id=${params}`);
  }
// 编辑企业主
export function editShareholderInfo(params) {
    return http.post('/merchant/faceAuth/updateShareholderInfo', params);
}
// 提交审核
export function submitAudit(params) {
  return http.post('/merchant/faceAuth/submitAudit');
}
// 人脸认证
export function startAuth(params) {
  return http.post('/merchant/faceAuth/startAuth', params);
}
// 查询发送记录
export function queryEmailSendRecord(params) {
  return http.get(`/merchant/faceAuth/queryEmailSendRecord?id=${params}`);
}
